<template>
  <div class="overflow-x-auto w-full" v-if="cuentosMostrados.length">
    <table class="min-w-full border border-gray-200 text-sm">
      <thead class="bg-gray-100">
        <tr>
          <th class="text-left px-4 py-2 border-b">Título</th>
          <th class="text-center px-4 py-2 border-b">Votos</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cuento, index) in cuentosMostrados" :key="index" class="hover:bg-gray-50">
          <td class="px-4 py-2 border-b text-gray-700">
            <router-link :to="`/mi-taller/votar-audio?id=${cuento.documentId}`"
              class="font-medium flex gap-2 text-gray-700 hover:text-gray-900 transition-colors">
              <img v-if="cuento.bala" src="https://www.onlygfx.com/wp-content/uploads/2021/10/bullet-9764.jpg"
                class="w-5 h-5 rounded-full" /> {{ cuento.titulo }}
            </router-link>
          </td>
          <td class="px-4 py-2 border-b text-center">
            <div class="flex justify-center items-center">
              <svg v-for="star in 5" :key="star" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4" :class="{
                  'text-yellow-500': star <= cuento.votos,
                  'text-gray-300': star > cuento.votos,
                }">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
              </svg>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Botón Ver más -->
    <div v-if="mostrarVerMas" class="flex justify-center mt-4">
      <button @click="cargarMas" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
        Ver más
      </button>
    </div>
  </div>
  <!-- Sino mostrar mensaje para ir a votar -->
  <div v-else class="text-center mt-8">
    <p class="text-gray-600">
      No votaste ningún cuento aún. ¿Qué estás esperando?
    </p>
    <router-link to="/mi-taller/votar-audio" class="text-blue-500 hover:underline">¡Vota ahora!</router-link>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import strapiService from '@/services/strapi';

const SERVER = "https://staging-strapi.orsai.org";

export default {
  data() {
    return {
      cuentos: [], // Datos acumulados
      cuentosMostrados: [], // Cuentos visibles en la tabla
      totalCuentos: 0, // Total de cuentos votados
      paginaActual: 1, // Página actual
      limitePorPagina: 10, // Número de cuentos por página
      totalPaginas: 1, // Total de páginas
      mostrarVerMas: false, // Mostrar botón "Ver más"
    };
  },
  computed: {
    computedUserId() {
      const authStore = useAuthStore();
      return authStore.usuario?.id || 1384; // Manejar casos donde no haya usuario
    },
  },
  methods: {
    async fetchCuentos() {
      try {
        if (!this.computedUserId) {
          console.error("No se pudo obtener el ID del usuario.");
          return;
        }

        const response = await strapiService.getCuentosAudioVotadosPorUsuario(
          this.computedUserId,
          this.paginaActual,
          this.limitePorPagina
        );
        const data = await response.json();

        console.log("Cuentos votados por el usuario (página):", data);

        // Agregar cuentos nuevos a los acumulados
        this.cuentos = [...this.cuentos, ...data.data];
        this.totalCuentos = data.meta.total;
        this.totalPaginas = Math.ceil(this.totalCuentos / this.limitePorPagina);

        // Actualizar cuentos mostrados
        this.cuentosMostrados = this.cuentos;

        // Determinar si mostrar el botón "Ver más"
        this.mostrarVerMas = this.paginaActual < this.totalPaginas;
      } catch (error) {
        console.error("Error al cargar los cuentos:", error);
      }
    },
    cargarMas() {
      // Incrementar la página actual y cargar más datos
      if (this.paginaActual < this.totalPaginas) {
        this.paginaActual++;
        this.fetchCuentos();
      }
    },
  },
  mounted() {
    this.fetchCuentos();
  },
};
</script>

<style>
/* Estilo opcional */
</style>
